const navs = [];

if (process.env.APP_MODE === 'manager') {
  Array.prototype.push.apply(navs, [
    {
      name: '仪表盘',
      to: '/dashboard',
      exact: true,
      strict: true,
      icon: 'icon-dashboard',
      // display: (user) => !!user.isTouer,
      display: true,
    },
    {
      name: '工作台',
      to: '/workspace',
      exact: true,
      strict: false,
      icon: 'icon-workspace',
      display: (user) => true,
    },
    {
      name: '工单列表',
      to: '/orders',
      exact: true,
      strict: false,
      icon: 'icon-orders',
      display: true,
    },
    {
      name: '财务报表',
      to: '/finances',
      exact: true,
      strict: false,
      icon: 'icon-finances',
      display: (user) => !!user.isTouer,
    },
    {
      name: '广告管理',
      to: '/banner',
      exact: true,
      strict: false,
      icon: 'icon-ico_AD',
      display: (user) => !!user.isAdmin,
    },
    {
      name: '企业管理',
      to: '/enterprises',
      exact: true,
      strict: false,
      icon: 'icon-enterprises',
      display: true,
    },
    {
      name: '注册用户',
      to: '/members',
      exact: true,
      strict: false,
      icon: 'icon-members',
      display: true,
    },
    {
      name: '师傅管理',
      to: '/workers',
      exact: true,
      strict: false,
      icon: 'icon-workers',
      display: true,
    },
    {
      name: '客服管理',
      to: '/managers',
      exact: true,
      strict: false,
      icon: 'icon-managers',
      display: (user) => !!user.isTouer,
    },
    {
      name: '佣金返利',
      to: '/referrals',
      exact: true,
      strict: false,
      icon: 'icon-referrals',
      display: (user) => !!user.isTouer,
    },
    {
      name: '消息管理',
      to: '/notifies',
      exact: true,
      strict: false,
      icon: 'icon-notifies',
      display: true,
    },
    {
      name: '奖券管理',
      to: '/coupon',
      exact: true,
      strict: false,
      display: (user) => !!user.isAdmin,
      icon: 'icon-coupon',
      children: [
        {
          name: '代金券管理',
          to: '/cashCoupon',
          exact: true,
          strict: false,
          display: (user) => !!user.isAdmin,
        },
        {
          name: '奖金券管理',
          to: '/bonusCoupon',
          exact: true,
          strict: false,
          display: (user) => !!user.isAdmin,
        }]
    },
  ]);
}

if (process.env.APP_MODE === 'tenant') {
  Array.prototype.push.apply(navs, [
    {
      permission: 'workspace',
      name: '工作台',
      to: '/workspace',
      exact: true,
      strict: false,
      icon: 'icon-workspace',
    },
    {
      permission: 'orders',
      name: '历史工单',
      to: '/orders',
      exact: true,
      strict: false,
      icon: 'icon-orders',
    },
    {
      permission: 'finances',
      name: '财务中心',
      to: '/finances',
      exact: true,
      strict: false,
      icon: 'icon-finances',
    },
    {
      permission: 'products',
      name: '产品信息',
      to: '/products',
      exact: true,
      strict: false,
      icon: 'icon-products',
    },
    {
      permission: 'orders',
      name: '工单配置',
      to: '/configure',
      exact: true,
      strict: false,
      icon: 'icon-orders',
    },
    {
      permission: 'employees',
      name: '员工管理',
      to: '/employees',
      exact: true,
      strict: false,
      icon: 'icon-employees',
    },
    {
      permission: 'orders',
      name: '功能介绍',
      to: '/helps',
      exact: true,
      strict: false,
      icon: 'icon-helps',
    },
    {
      permission: 'orders',
      name: '邀请推广',
      to: '/invitation',
      exact: true,
      strict: false,
      icon: 'icon-invitation',
    },
    {
      permission: 'orders',
      name: '账号管理',
      to: '/account',
      exact: true,
      strict: false,
      icon: 'icon-account',
    }
  ]);
}

export default function getNavs(user) {
  if (!user || !user._id) {
    return [];
  }

  return navs.filter((item) => {
    // 非tenant端沿用旧规则，tenant通过 permissions 及管理员验证
    if (process.env.APP_MODE !== 'tenant') {
      if (typeof item.display === 'function') {
        return item.display(user);
      }
      return !!item.display;
    } else {
      if (user.isTouer) {
        return true;
      }
      if (typeof item.permission !== 'undefined') {
        // have Permission
        return user.staff?.permissions?.some(
          (permission) => ~permission.indexOf(item.permission)
        );
      }
      return false;
    }
  });
}
